import { t } from 'i18next';

// Common and Widgets
import { Illustrations } from '@/common/support/illustrationsRegistry';
import { KincodeButton } from '@/components/button/KincodeButton';
import { UnifiedIcon } from '@/components/UnifiedIcon';
import { useCompanyBrand } from '@/hooks/useCompanyBrand';

// -----------------------------------------------------------------------------
// Runtime / render error UI — same personalization pattern as Forbidden, distinct copy & art.
// Must render under DataProvider.
// -----------------------------------------------------------------------------
/**
 * @param {{ onGoHome: () => void }} props
 */
export function ErrorBoundaryShell({ onGoHome }) {
  const { colorHex, buttonTheme } = useCompanyBrand();

  return (
    <>
      {/*
        Viewport-bounded scroll: short content stays vertically centered;
        tall content (illustration + copy + CTA) can scroll instead of clipping.
      */}
      <div
        className="flex h-dvh flex-col overflow-y-auto bg-bg-canvas dark:bg-bg-canvas-dark"
        data-testid="common-error-boundary"
      >
        <div className="flex min-h-full flex-col justify-center px-4 py-8 sm:px-8 sm:py-12">
          <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-8 sm:gap-12">
            <div className="flex w-full justify-center px-4 sm:px-8">
              <Illustrations
                name="KAI500"
                className="mx-auto h-auto max-h-[40vh] max-w-md w-full object-contain"
              />
            </div>

            <div className="flex flex-col items-center gap-4 px-2">
              <h2 className="flex flex-row type-display text-center">
                <span className="text-gray-900 dark:text-gray-50">{t('error.boundary.title')}</span>
              </h2>
              <h5 className="flex flex-row justify-between items-center text-center type-h5 text-kc-gray-dark dark:text-kc-gray-light">
                {t('error.boundary.description')}
              </h5>
            </div>

            <div className="flex flex-col items-center gap-4" data-testid="common-error-boundary-actions">
              <KincodeButton
                variant="primary"
                theme={buttonTheme}
                colorHex={colorHex}
                onClick={onGoHome}
                ariaLabel={t('error.boundary.cta')}
                data-testid="common-error-boundary-go-home"
              >
                <UnifiedIcon name="ArrowLeft" library="phosphor" className="h-4 w-4 shrink-0" />
                {t('error.boundary.cta')}
              </KincodeButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
